import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, Icon
// SelectMenu
} from '@livable/saas-react-components';
import { Accordion, AccordionDetails, AccordionSummary, Button, List, ListItem,
// MenuItem,
Paper,
// TextField,
Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'src/stores';
import useStyles from './styles';
export default function OverviewTab() {
  const classes = useStyles();
  const navigate = useNavigate();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // const [sort, setSort] = useState('asc');
  // const handleSortChange = event => {
  //   if (event.target.value) setSort(event.target.value);
  // };
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const getCompanyPropertyList = async () => {
    const resp = await store.company.getCompanyPropertyListAsync.run();
    return resp;
  };
  useEffect(() => {
    setIsLoading(true);
    getCompanyPropertyList().finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.filterHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('reporting.property_overview')))), store.company.companyPropertyList.map(data => /*#__PURE__*/React.createElement(Paper, {
    className: classes.addressBlock,
    key: data.propertyId
  }, /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "allocation-content",
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      type: "arrow-line-right"
    }),
    id: "allocation-header"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, data.propertyAddress)), /*#__PURE__*/React.createElement(AccordionDetails, {
    className: classes.accordionDetails
  }, /*#__PURE__*/React.createElement(List, {
    variant: "white"
  }, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('reporting.ar_summary_report')), /*#__PURE__*/React.createElement("div", {
    className: classes.actionButton
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => navigate("/ar_report?propertyId=".concat(data.propertyId)),
    variant: "contained",
    size: "small",
    'custom-attribute': '786-reporting-page-transaction-table'
  }, t('reporting.open_report'))))))))));
}